import { cn } from '@tripleten/cn';

export const cnCollapsible = cn('collapsible');
